import { getDocByProductId } from '@/services/document-next';
import { message } from 'antd';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();
const articleUrl = publicRuntimeConfig.articleBaseUrl;

/**
 * 根据 productId/productCode 获取上线的文档，并前往文档详情
 * @param productId 文档id
 * @param openNewWindow 是否需要开新tab跳转（NOTE: 在mobile browser中新开页面会被拦截，导致无响应）
 */
export async function gotoArticleByProduct(
  product: {
    productId?: number;
    productCode?: string;
  },
  openNewWindow = true
) {
  // 获取第上线的第一篇文章
  const res = await getDocByProductId(product);
  // 如果没有结文章，会跳转到一个显示暂无文章的空页面
  const targetLink =
    res && res.length
      ? `${articleUrl}/${product.productCode}/${res[0].docId}`
      : `${articleUrl}/${product.productCode}`;
  openNewWindow
    ? window.open(targetLink, '_blank')
    : location.assign(targetLink);
}

/**
 * 根据 productId/productCode 获取上线的文地址
 * @param product
 * @param gotoWhenArticleIsEmpty
 */
export async function getArticleUrlProduct(product: {
  productId?: number;
  productCode?: string;
}) {
  const res = await getDocByProductId(product);
  let url;
  if (res && res.length) {
    url = `${articleUrl}/${res[0].docId}`;
  } else {
    url = `${articleUrl}?product=${product.productId || product.productCode}`;
  }
  return url;
}

interface INav {
  docsKey?: string;
  key: string;
  title: string;
  isOnline: boolean;
  children: INav[];
}
interface IDocListItem {
  docId: string;
  docName: string;
}
/**
 * 根据产品文档Nav获取已上线文档的的一维列表
 * @param nav
 */
export function getDocListByNav(nav: INav[]): IDocListItem[] {
  const res: IDocListItem[] = [];
  nav
    .filter((item) => item.isOnline)
    .forEach((item) => {
      if (item.children) {
        const temp = getDocListByNav(item.children);
        res.push(...temp);
      } else {
        res.push({ docId: item.docsKey || item.key, docName: item.title });
      }
    });
  return res;
}
